import { vs2jen2LimitedReleasesListConstants } from "../_redux-constants";

export function vs2jen2LimitedReleasesListReducer(
  state = {
    vs2jen2LimitedReleasesListLoading: false,
    vs2jen2LimitedReleasesListData: null,
    vs2jen2LimitedReleasesListError: null,
  },
  action
) {
  switch (action.type) {
    case vs2jen2LimitedReleasesListConstants.VS2JEN2_LIMITED_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        vs2jen2LimitedReleasesListLoading: true,
        vs2jen2LimitedReleasesListData: null,
        vs2jen2LimitedReleasesListError: null,
      });
    case vs2jen2LimitedReleasesListConstants.VS2JEN2_LIMITED_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        vs2jen2LimitedReleasesListLoading: false,
        vs2jen2LimitedReleasesListData: action.data,
      });
    case vs2jen2LimitedReleasesListConstants.VS2JEN2_LIMITED_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        vs2jen2LimitedReleasesListLoading: false,
        vs2jen2LimitedReleasesListData: null,
        vs2jen2LimitedReleasesListError: action.error,
      });
    default:
      return state;
  }
}
